import queryString from 'query-string';

export function hasUTMParam(url: string) {
  return (
    Object.keys(queryString.parse(url.split('?')[1])).filter((p) =>
      p.startsWith('utm_'),
    ).length > 0
  );
}
